module.exports = __webpack_public_path__ + "static/media/keith-2.238aec92.jpg";